import { UrlUtil, _ } from '@hugendubel/utils';

var Config = {
    active: false,
    appName: 'not_configured',
    loggedIn: function () { return false; },
    prod: true,
    queryParamWhitelist: [],
};
var Globals = {
    window: function () { return window; },
    newImage: function () { return new Image(); },
    timestamp: function () { return Date.now(); },
    navigator: function () { return navigator; },
    onLine: function () { return !('onLine' in Globals.navigator()) || Globals.navigator().onLine; },
    config: function () { return Config; },
};

var getErrorCodeOrMessage = function (error) {
    if (!error)
        return undefined;
    var message = error.message, errorCode = error.errorCode, statusDetails = error.statusDetails;
    var errorStr = errorCode ? String(errorCode) : message || 'unknown error';
    var detailsStr = statusDetails && statusDetails.length > 0 ? statusDetails.map(function (details) { return details.code; }).join(',') : undefined;
    return detailsStr ? errorStr + "/" + detailsStr : errorStr;
};
var sendWithImage = function (type, data) {
    var nonce = UrlUtil.getNonce();
    Globals.newImage().src = '/wsapi/rest/v1/logging/log?' + UrlUtil.queryToString({ type: type, data: data, nonce: nonce });
};
var ensureArray = function (array) { return (array ? array : []); };
var filterQueryParams = function (whitelist, queryString) {
    if (!queryString)
        return undefined;
    var query = UrlUtil.locationSearchToQuery(queryString);
    return (Object.keys(query)
        .filter(function (key) { return whitelist.indexOf(key) !== -1; })
        .map(function (key) { return key + "=" + query[key]; })
        .join('&') || undefined);
};
var Utils = { getErrorCodeOrMessage: getErrorCodeOrMessage, sendWithImage: sendWithImage, ensureArray: ensureArray, filterQueryParams: filterQueryParams };

// When the tracking client is configured it will be activated
var configure = function (_a) {
    var loginAccessor = _a.loginAccessor, appName = _a.appName, queryParamWhitelist = _a.queryParamWhitelist, prod = _a.prod;
    var config = Globals.config();
    config.active = true;
    config.appName = appName;
    loginAccessor && (config.loggedIn = loginAccessor);
    queryParamWhitelist && (config.queryParamWhitelist = queryParamWhitelist);
    prod !== undefined && (config.prod = prod);
};
// Timestamp to uniquely identify where the tracking event originated from
// Expected format is yyyy-MM-dd hh:mm:ss
var TRACK_ID = function (id) { return ({ _internal: id }); };
var trackEvent = function (trackingId, type, customData) {
    var location = Globals.window().location;
    var data = {
        id: trackingId._internal,
        app: Globals.config().appName,
        dom: location.hostname,
        pth: location.pathname,
        qry: Utils.filterQueryParams(Globals.config().queryParamWhitelist, location.search),
        ms: Globals.timestamp(),
        li: Globals.config().loggedIn(),
        cd: customData,
    };
    // do not send data to the WSAPI if offline or not active
    if (!Globals.config().active || !Globals.onLine()) {
        Globals.config().prod || Globals.window().console.log('WSAPI tracking inactive!', data);
        return;
    }
    Utils.sendWithImage(type, JSON.stringify(data));
};
var info = function (trackId, message) {
    Globals.config().prod || Globals.window().console.log(trackId, message);
    trackEvent(trackId, 'INFO', { m: message });
};
var error = function (trackId, message) {
    Globals.config().prod || Globals.window().console.error(trackId, message);
    trackEvent(trackId, 'ERROR', { m: message });
};
var submit = function (trackId, status, validationError, error) {
    var errorFields = [];
    var errorIds = [];
    validationError &&
        _.forEach(validationError, function (value, key) {
            if (value) {
                errorFields.push(key);
                errorIds.push(value.id);
            }
        });
    trackEvent(trackId, 'SUBMIT', {
        st: status,
        flds: errorFields.join('|') || undefined,
        ids: errorIds.join('|') || undefined,
        code: Utils.getErrorCodeOrMessage(error),
    });
};
var submitSuccess = function (trackId) {
    submit(trackId, 'SUCCESS');
};
var submitError = function (trackId, validationError, error) {
    submit(trackId, 'ERROR', validationError, error);
};
var navigation = function (trackId, type, action, target) {
    trackEvent(trackId, 'NAVIGATION', {
        nt: type,
        ac: action,
        tg: target,
    });
};
var selection = function (trackId, optionNamesOrLength, choiceIndex) {
    var isArray = Array.isArray(optionNamesOrLength);
    trackEvent(trackId, 'SELECTION', {
        on: isArray ? optionNamesOrLength : undefined,
        oc: isArray ? undefined : optionNamesOrLength,
        ci: choiceIndex,
    });
};
var article = function (trackId, article, amount, action, source, target, error, index, rating) {
    trackEvent(trackId, 'ARTICLE', {
        ac: action,
        tg: target,
        sc: source,
        st: error ? 'ERROR' : 'SUCCESS',
        amt: amount,
        aid: article.articleId,
        pr: article.price ? article.price : 0,
        ti: article.title,
        au: article.authors,
        pc: article.binderName,
        am: article.availabilityMessage,
        ra: rating,
        i: index,
        ec: Utils.getErrorCodeOrMessage(error),
    });
};
var order = function (trackId, action, _a, error) {
    var pickupBranchId = _a.pickupBranchId, deliveryType = _a.deliveryType, paymentType = _a.paymentType, items = _a.items, invalidItems = _a.invalidItems, shippingCosts = _a.shippingCosts, couponAmount = _a.couponAmount, total = _a.total, giftWrapCosts = _a.giftWrapCosts, _b = _a.collisions, collisions = _b === void 0 ? [] : _b;
    trackEvent(trackId, 'ORDER', {
        ac: action,
        st: collisions.length || error ? 'ERROR' : 'SUCCESS',
        art: items.map(function (item) { return ({ aid: item.articleId, aa: item.amount || 0, ap: item.price || 0 }); }),
        iaid: Utils.ensureArray(invalidItems).map(function (item) { return (item.articleId ? item.articleId.toString() : 'NULL'); }),
        pay: paymentType,
        del: deliveryType,
        bid: pickupBranchId,
        sc: shippingCosts,
        dis: couponAmount,
        tot: total,
        eid: collisions,
        ec: Utils.getErrorCodeOrMessage(error),
        gw: giftWrapCosts,
    });
};
var Track = {
    configure: configure,
    error: error,
    submitError: submitError,
    submitSuccess: submitSuccess,
    navigation: navigation,
    info: info,
    selection: selection,
    article: article,
    order: order,
};

export { TRACK_ID, Track, Utils };
